import { isLocked } from './lock';
import type { Game, WeekSheet } from './types';

/** Drop unlocked picks (and the tiebreaker if that game is still open). Locked games stay. */
export function clearUnlockedSheet(
  sheet: WeekSheet,
  games: Game[],
  tiebreakerGameId: string | null,
  now: Date = new Date(),
): WeekSheet {
  const picks = { ...sheet.picks };
  for (const game of games) {
    if (!isLocked(game.kickoffUtc, now)) delete picks[game.id];
  }
  const tb = games.find((g) => g.id === tiebreakerGameId);
  const keepTiebreaker = Boolean(tb && isLocked(tb.kickoffUtc, now));
  return {
    ...sheet,
    picks,
    tiebreaker: keepTiebreaker ? sheet.tiebreaker : undefined,
  };
}

export function unlockedGameIds(games: Game[], now: Date = new Date()): string[] {
  return games.filter((g) => !isLocked(g.kickoffUtc, now)).map((g) => g.id);
}
